/* ── Quintas de Seia — Wishlist (localStorage) ── */

var Wishlist = (function () {
  var STORAGE_KEY = 'qs_wishlist';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function has(handle) {
    return getAll().some(function (p) { return p.handle === handle; });
  }

  function add(product) {
    if (has(product.handle)) return;
    var items = getAll();
    items.push(product);
    save(items);
    dispatch('wishlist:change', { items: items });
  }

  function remove(handle) {
    var items = getAll().filter(function (p) { return p.handle !== handle; });
    save(items);
    dispatch('wishlist:change', { items: items });
  }

  function toggle(product) {
    if (has(product.handle)) {
      remove(product.handle);
      return false;
    } else {
      add(product);
      return true;
    }
  }

  function count() {
    return getAll().length;
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  return { getAll: getAll, has: has, add: add, remove: remove, toggle: toggle, count: count };
})();

/* ── Button behaviour ── */

function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
    var handle = btn.dataset.wishlistHandle;
    updateBtn(btn, Wishlist.has(handle));

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var product = {
        handle:  handle,
        title:   btn.dataset.wishlistTitle,
        price:   btn.dataset.wishlistPrice,
        image:   btn.dataset.wishlistImage,
        url:     btn.dataset.wishlistUrl
      };
      var added = Wishlist.toggle(product);
      updateBtn(btn, added);

      // Brief pulse animation
      btn.classList.add('wishlist-btn--pulse');
      setTimeout(function () { btn.classList.remove('wishlist-btn--pulse'); }, 400);
    });
  });
}

function updateBtn(btn, active) {
  btn.classList.toggle('wishlist-btn--active', active);
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  btn.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
}

/* ── Badge ── */

function updateBadge() {
  var n = Wishlist.count();
  document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
    el.textContent = n > 99 ? '99+' : n;
    el.hidden = n === 0;
  });
}

/* ── Wishlist page rendering ── */

function formatMoneyCents(cents) {
  var euros = Number(cents) / 100;
  if (Number.isNaN(euros)) return '';
  var opts = { style: 'currency', currency: 'EUR' };
  if (euros % 1 === 0) {
    opts.minimumFractionDigits = 0;
    opts.maximumFractionDigits = 0;
  }
  return new Intl.NumberFormat('pt-PT', opts).format(euros);
}

function formatProductApiPrice(product) {
  var min = parseFloat(product.price_min != null ? product.price_min : product.price);
  var max = parseFloat(product.price_max != null ? product.price_max : product.price);
  if (Number.isNaN(min)) return '';
  var formatted = formatMoneyCents(min);
  if (product.price_varies || (!Number.isNaN(max) && max > min)) {
    return 'A partir de ' + formatted;
  }
  return formatted;
}

function renderWishlistPage() {
  var container = document.getElementById('wishlist-page-items');
  var empty     = document.getElementById('wishlist-page-empty');
  if (!container) return;

  var items = Wishlist.getAll();

  if (items.length === 0) {
    container.hidden = true;
    if (empty) empty.hidden = false;
    return;
  }

  container.hidden = false;
  if (empty) empty.hidden = true;

  container.innerHTML = items.map(function (p) {
    return [
      '<div class="wishlist-card" data-wishlist-card="' + p.handle + '">',
        '<a href="' + p.url + '" class="wishlist-card__img-link">',
          p.image
            ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" class="wishlist-card__img" loading="lazy" width="300" height="300">'
            : '<div class="wishlist-card__img-placeholder"></div>',
        '</a>',
        '<div class="wishlist-card__info">',
          '<a href="' + p.url + '" class="wishlist-card__title">' + escapeHtml(p.title) + '</a>',
          '<p class="wishlist-card__price" data-wishlist-price-el>' + escapeHtml(p.price || '') + '</p>',
        '</div>',
        '<button',
          ' type="button"',
          ' class="wishlist-card__remove"',
          ' data-wishlist-remove="' + p.handle + '"',
          ' aria-label="Remover ' + escapeHtml(p.title) + ' dos favoritos"',
        '>',
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
      '</div>'
    ].join('');
  }).join('');

  container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = btn.dataset.wishlistRemove;
      Wishlist.remove(handle);
      var card = container.querySelector('[data-wishlist-card="' + handle + '"]');
      if (card) {
        card.classList.add('wishlist-card--removing');
        setTimeout(function () { renderWishlistPage(); }, 300);
      }
    });
  });

  refreshWishlistPrices(items, container);
}

function refreshWishlistPrices(items, container) {
  var updated = false;
  var pending = items.map(function (item) {
    return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (product) {
        var priceLabel = formatProductApiPrice(product);
        if (!priceLabel) return;
        var card = container.querySelector('[data-wishlist-card="' + item.handle + '"]');
        var priceEl = card && card.querySelector('[data-wishlist-price-el]');
        if (priceEl) priceEl.textContent = priceLabel;
        if (item.price !== priceLabel) {
          item.price = priceLabel;
          updated = true;
        }
        if (product.featured_image && !item.image) {
          item.image = product.featured_image;
          updated = true;
          if (card) {
            var link = card.querySelector('.wishlist-card__img-link');
            if (link) {
              link.innerHTML = '<img src="' + product.featured_image + '" alt="' + escapeHtml(item.title) + '" class="wishlist-card__img" loading="lazy" width="300" height="300">';
            }
          }
        }
      })
      .catch(function () {});
  });

  Promise.all(pending).then(function () {
    if (updated) {
      try {
        localStorage.setItem('qs_wishlist', JSON.stringify(items));
      } catch (e) {}
    }
  });
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ── Bootstrap ── */

document.addEventListener('DOMContentLoaded', function () {
  initWishlistButtons();
  updateBadge();
  renderWishlistPage();

  document.addEventListener('wishlist:change', function () {
    updateBadge();
    // Re-sync all buttons on the page
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      updateBtn(btn, Wishlist.has(btn.dataset.wishlistHandle));
    });
  });
});
